import { ReactElement } from 'react';
import ApsBigIcon from 'assets/logo-icons/aps-big-logo.icon.svg?react';
import { SBackdrop, SLoaderInner, SLoaderMessage, SPreloader, SPreloaderSweep } from './loader.component.styles.ts';

interface ILoaderProps {
  fullscreen?: boolean;
  spinning?: boolean;
  message?: string;
}

export const Loader = ({ fullscreen, spinning, message }: ILoaderProps): ReactElement | null => {
  if (!spinning) {
    return null;
  }

  const preloader = (
    <SPreloader $big={fullscreen}>
      <ApsBigIcon />
      <SPreloaderSweep $big={fullscreen}>
        <ApsBigIcon />
      </SPreloaderSweep>
    </SPreloader>
  );

  if (fullscreen) {
    return (
      <SBackdrop>
        <SLoaderInner>
          {preloader}
          {message && <SLoaderMessage className="p2">{message}</SLoaderMessage>}
        </SLoaderInner>
      </SBackdrop>
    );
  }

  return preloader;
};

Loader.defaultProps = {
  fullscreen: false,
  spinning: true,
  message: undefined,
};
